import { useEffect, useState } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';

import { supabase } from '@/lib/supabase';

const SEEN_KEY = 'global_announcement_seen_id';

export type Announcement = { id: string; title: string; body: string } | null;

/**
 * Γενική ανακοίνωση προς όλους τους χρήστες (modal στο άνοιγμα της
 * εφαρμογής) — διαβάζεται από app_config (announcement_id/title/body).
 * Αλλάζοντας το announcement_id ξαναδείχνεται σε όλους, ακόμα κι αν είχαν
 * ήδη δει προηγούμενη ανακοίνωση (per-device dismissal μέσω AsyncStorage).
 */
export function useAnnouncement() {
  const [announcement, setAnnouncement] = useState<Announcement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    void (async () => {
      const { data, error } = await supabase
        .from('app_config')
        .select('key, value')
        .in('key', ['announcement_id', 'announcement_title', 'announcement_body']);
      if (error || !data) return;

      const cfg: Record<string, string> = {};
      data.forEach((row: { key: string; value: string }) => { cfg[row.key] = row.value; });
      const id = cfg['announcement_id']?.trim();
      if (!id || !cfg['announcement_title'] || !cfg['announcement_body']) return;

      const seenId = await AsyncStorage.getItem(SEEN_KEY);
      if (seenId === id) return;

      setAnnouncement({ id, title: cfg['announcement_title'], body: cfg['announcement_body'] });
      setVisible(true);
    })();
  }, []);

  function dismiss() {
    setVisible(false);
    if (announcement) void AsyncStorage.setItem(SEEN_KEY, announcement.id);
  }

  return { announcement, visible, dismiss };
}
